import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Add CSS import

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>庐山杏林中药植物研究所</h3>
          <p>江西省九江市庐山区</p>
          <p>邮编: 332900</p>
          <p>电话: 0792-2188999 或 0792-2199888</p>
          <p>邮箱: xinglinzhongyao@126.com</p>
        </div>
        
        <div className="footer-section">
          <h3>快速链接</h3>
          <ul>
            <li><Link to="/">首页</Link></li>
            <li><Link to="/garden">杏林花园</Link></li>
            <li><Link to="/plants">植物展示</Link></li>
            <li><Link to="/visit">参观游览</Link></li>
            <li><Link to="/events">近期活动</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>更多信息</h3>
          <ul>
            <li><Link to="/learning">科学教育</Link></li>
            <li><Link to="/about-us">关于我们</Link></li>
            <li><Link to="/support-us">支持我们</Link></li>
            {/* 暂时隐藏联系我们链接，因为没有对应的轮播分类 */}
            {/* <li><Link to="/contact">联系我们</Link></li> */}
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} 庐山杏林中药植物研究所. 版权所有.</p>
        <div className="footer-links">
          <Link to="/support-us">支持我们</Link>
          <span className="footer-separator">|</span>
          <Link to="/privacy">隐私政策</Link>
          <span className="footer-separator">|</span>
          <Link to="/terms">使用条款</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;